import { useSelector } from "react-redux"
import { hasPermission, PermissionLevel, PermissionLevelValue } from "helpers/permissions"
import { isPermissionedResource, ResourceType } from "helpers/permissions/resource-types"
import { getRole } from "helpers/permissions/roles"
import { Uuid } from "helpers/types/uuid"
import useResource from "./resources"

// [TODO:TS] Refine type
interface ResourceMeta {
  permissionLevel?: PermissionLevel
}

export function useResourcePermission(resourceType: ResourceType, resourceId: string | Uuid) {
  return useResource<PermissionLevel>({
    resource: `resourcePermission-${resourceId}`,
    url: () => isPermissionedResource(resourceType) ? ({
      id: `resourcePermission-${resourceId}`,
      query: `query ($resourceType: ResourceType!, $resourceId: IdOrShortIdOrAlias!) {
        resource(type: $resourceType, id: $resourceId) {
          id
          permissionLevel
        }
      }`,
      variables: { resourceType, resourceId },
    }) : null,
  }, ["resource", "permissionLevel"])
}

// [TODO] make useHasResourcePermission more generic than resourceMetadata
//  e.g. pass in a resourceId, resourceType, and permissionLevel,
//  then retrieve the resourceMetadata from the resourceId and resourceType,
//  then check if the resourceMetadata has the permissionLevel,
//  then return the permission.
export function useHasResourcePermission(resourceMetadata: ResourceMeta | undefined, permissionLevel: PermissionLevelValue) {
  const role = useSelector(getRole)
  if (role === "admin") {
    return true
  }

  if (!resourceMetadata || resourceMetadata.permissionLevel === undefined) {
    return false
  }

  return hasPermission(resourceMetadata.permissionLevel, permissionLevel)
}
